import { useEffect, useState } from "react";

const MINUTE = 60_000;

export function useNow(active: boolean): Date {
	const [now, setNow] = useState(() => new Date());

	useEffect(() => {
		if (!active) return;
		const timer = setInterval(() => setNow(new Date()), MINUTE);
		return () => clearInterval(timer);
	}, [active]);

	return now;
}
